<template>
  <form autocomplete="off">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content v-if="everythingLoaded">
        <ValidationProvider
          name="name"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Naam</label>
            <md-input v-model="name" type="text"> </md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="order"
          rules="required"
          v-slot="{ passed, failed }"
        >
          <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            <label>Volgorde</label>
            <md-select
              v-model="order"
              name="order"
              id="order"
              required
              :disabled="requesting"
            >
              <md-option
                v-for="(orderOption, index) in [
                  1,
                  2,
                  3,
                  4,
                  5,
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  13,
                  14,
                  15,
                  16,
                  17,
                  18,
                  19,
                  20,
                  21,
                  22,
                  23,
                  24,
                  25,
                  26,
                  27,
                  28,
                  29,
                  30,
                  31,
                  32,
                  33,
                  34,
                  35,
                  36,
                  37,
                  38,
                  39,
                  40,
                  41,
                  42,
                  43,
                  44,
                  45,
                  46,
                  47,
                  48,
                  49,
                  50,
                  51,
                  52,
                  53,
                  54,
                  55,
                  56,
                  57,
                  58,
                  59,
                  60,
                  61,
                  62,
                  63,
                  64,
                  65,
                  66,
                  67,
                  68,
                  69,
                  70,
                  71,
                  72,
                  73,
                  74,
                  75,
                  76,
                  77,
                  78,
                  79,
                  80,
                  81,
                  82,
                  83,
                  84,
                  85,
                  86,
                  87,
                  88,
                  89,
                  90,
                  91,
                  92,
                  93,
                  94,
                  95,
                  96,
                  97,
                  98,
                  99
                ]"
                :value="orderOption"
                :key="index"
                >{{ orderOption }}</md-option
              >
            </md-select>
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <template>
          <h4 class="card-title">Rollen</h4>
          <p>
            Gebruikers met de volgende rollen krijgen de extra invoer velden die
            aan deze groep zijn toegevoegd.
          </p>
          <template v-for="(role, index) in allRolesBooleans">
            <md-switch
              :key="index"
              v-model="allRolesBooleans[index]"
              :disabled="!canChangeRole(allRoles[index].id)"
            >
              {{ allRoles[index].label }}
            </md-switch>
          </template>
        </template>
      </md-card-content>

      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
          >Terug</md-button
        >
        <md-button
          :disabled="!formTouched"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
          >Opslaan</md-button
        >
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import swal from "sweetalert2";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      boolean: null,
      requesting: false,
      name: "",
      order: "",
      userRoles: [],
      allRoles: [],
      allRolesBooleans: [],
      touched: {
        name: false,
        order: false,
        allRolesBooleans: false
      },
      loaded: {
        fieldGroup: false,
        fieldGroupRoles: false,
        fieldGroupAllRoles: false
      },
      submitErrors: ""
    };
  },
  methods: {
    init() {
      if (this.$route.params.id !== undefined) {
        this.loadUserFieldGroup(this.$route.params.id);
        this.loadUserFieldGroupRoles(this.$route.params.id);
        this.loadUserFieldGroupAllAvailableRoles(this.$route.params.id);
      } else {
        this.name = "";
        this.order = "";

        setTimeout(this.resetTouched, 100);
      }
    },
    validate() {
      this.$http
        .post(
          this.$apiBaseUrl +
            (this.isDriverField
              ? "drivers/field/group/"
              : "users/field/group/") +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            name: this.name,
            order: this.order
          })
        )
        .then(
          response => {
            if (
              this.$route.params.id !== undefined &&
              this.touched.allRolesBooleans
            ) {
              this.saveUserFieldGroupUserRoles(this.$route.params.id);
            } else {
              setTimeout(this.resetTouched, 100);
              this.notifyVue(
                "Gebruikers veld groep succesvol opgeslagen",
                "check",
                "success",
                5000
              );

              if (this.$route.params.id === undefined) {
                this.$router.go(-1);
              }
            }
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan route",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    saveUserFieldGroupUserRoles(id) {
      this.$http
        .post(
          this.$apiBaseUrl +
            (this.isDriverField
              ? "drivers/field/group/"
              : "users/field/group/") +
            this.$route.params.id +
            "/roles",
          Object.assign({
            roleIds: this.allRolesBooleansSelectedRoleIds
          })
        )
        .then(
          response => {
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Gebruikers veld groep succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            // Go back when user roles have changed to prevent conflicts between user/driver only groups switching and then getting permission errors from the API
            this.$router.go(-1);
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan route",
                "report_problem",
                "danger",
                0
              );
            }
          }
        );
    },
    loadUserFieldGroup(id) {
      this.requesting = true;
      this.$http
        .get(
          this.$apiBaseUrl +
            (this.isDriverField
              ? "drivers/field/group/"
              : "users/field/group/") +
            id
        )
        .then(
          response => {
            this.name = response.data.fieldGroup.name;
            this.order = response.data.fieldGroup.order;

            setTimeout(this.resetTouched, 100);

            this.requesting = false;
            this.loaded.fieldGroup = true;
          },
          response => {
            this.requesting = false;
            if (response.status === 403) {
              // this.notifyVue("U heeft geen rechten voor het beheren van veld groupen", 'add_alert', 'danger', 0);
            }
          }
        );
    },
    loadUserFieldGroupRoles(id) {
      this.requesting = true;
      this.$http
        .get(
          this.$apiBaseUrl +
            (this.isDriverField
              ? "drivers/field/group/"
              : "users/field/group/") +
            id +
            "/roles"
        )
        .then(
          response => {
            this.userRoles = response.data.userRoles;

            setTimeout(this.resetTouched, 100);

            this.requesting = false;
            this.loaded.fieldGroupRoles = true;

            if (this.everythingLoaded) {
              this.connectRolesToButtons();
            }
          },
          response => {
            this.requesting = false;
            if (response.status === 403) {
              // this.notifyVue("U heeft geen rechten voor het beheren van veld groupen", 'add_alert', 'danger', 0);
            }
          }
        );
    },
    loadUserFieldGroupAllAvailableRoles() {
      this.requesting = true;
      this.$http
        .get(
          this.$apiBaseUrl +
            (this.isDriverField
              ? "drivers/field/groups/"
              : "users/field/groups/") +
            "roles"
        )
        .then(
          response => {
            this.allRoles = response.data.userRoles;

            setTimeout(this.resetTouched, 100);

            this.requesting = false;
            this.loaded.fieldGroupAllRoles = true;

            if (this.everythingLoaded) {
              this.connectRolesToButtons();
            }
          },
          response => {
            this.requesting = false;
            if (response.status === 403) {
              // this.notifyVue("U heeft geen rechten voor het beheren van veld groepen", 'add_alert', 'danger', 0);
            }
          }
        );
    },
    resetTouched() {
      this.touched.name = false;
      this.touched.order = false;
      this.touched.allRolesBooleans = false;
    },
    connectRolesToButtons() {
      for (var i in this.allRoles) {
        this.allRolesBooleans[i] = this.inArray(
          this.userRoleIds,
          this.allRoles[i].id
        );
      }
    },
    showSwal() {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, ga terug zonder op te slaan",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$router.go(-1);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    canChangeRole(roleId) {
      return !(
        this.inArray(this.allRolesBooleansSelectedRoleIds, roleId) &&
        this.allRolesBooleansSelectedRoleIds.length <= 1
      );
    },
    inArray(haystack, needle) {
      for (var i in haystack) {
        if (haystack[i] === needle) {
          return true;
        }
      }

      return false;
    }
  },
  watch: {
    name() {
      if (!this.requesting) {
        this.touched.name = true;
      }
    },
    order() {
      if (!this.requesting) {
        this.touched.order = true;
      }
    },
    allRolesBooleans() {
      if (!this.requesting) {
        this.touched.allRolesBooleans = true;
      }
    },
    $route(to, from) {
      this.init();
    }
  },
  computed: {
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    },
    userRoleIds: function() {
      let data = [];

      for (let i in this.userRoles) {
        data.push(this.userRoles[i].id);
      }

      return data;
    },
    allRolesBooleansSelectedRoleIds: function() {
      let data = [];

      for (let i in this.allRolesBooleans) {
        if (this.allRolesBooleans[i]) {
          data.push(this.allRoles[i].id);
        }
      }

      return data;
    },
    isDriverField: function() {
      if (this.$route.fullPath.indexOf("driver_field_groups") >= 0) {
        return true;
      }
      return false;
    },
    title: function() {
      if (this.$route.params.id !== undefined) {
        return "Gebruikers veld groep bewerken";
      }
      return "Gebruikers veld groep toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "table_rows";
      }
      return "table_rows";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }
      return false;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
</style>
